import { render } from "./Panel.vue?vue&type=template&id=c2a3d3b4&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=c2a3d3b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a3d3b4"],['__file',"src/Web/scripts/components/Panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2a3d3b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2a3d3b4', __exports__)) {
    api.reload('c2a3d3b4', __exports__)
  }
  
  module.hot.accept("./Panel.vue?vue&type=template&id=c2a3d3b4&scoped=true", () => {
    api.rerender('c2a3d3b4', render)
  })

}


export default __exports__